import { useQuery } from '@tanstack/react-query'
import { useRef } from 'react'
import {
  getActiveAnnouncements,
  ActiveAnnouncement,
} from '../services/notifications'

export const useMaintenanceModeCheck = () => {
  const previousMaintenanceMode = useRef<boolean | null>(null)

  const {
    data: announcements = [],
    isLoading,
    error,
    refetch,
  } = useQuery(['maintenanceAnnouncements'], getActiveAnnouncements, {
    refetchInterval: 1 * 60 * 1000,
    staleTime: 1 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    onSuccess: (data: ActiveAnnouncement[]) => {
      // Check if any announcement has message_type of MAINTENANCE
      const currentMaintenanceMode = data.some(
        (announcement) => announcement.message_type === 'MAINTENANCE',
      )

      // Only reload if maintenance mode changed from false to true
      // This prevents flickering when the page reloads
      if (
        previousMaintenanceMode.current === false &&
        currentMaintenanceMode === true
      ) {
        window.location.reload()
      }

      // Update the ref for next comparison
      if (previousMaintenanceMode.current === null) {
        previousMaintenanceMode.current = currentMaintenanceMode
      }
    },
  })

  // Check if any announcement has message_type of MAINTENANCE
  const isMaintenanceMode = announcements.some(
    (announcement: ActiveAnnouncement) =>
      announcement.message_type === 'MAINTENANCE',
  )

  return {
    announcements,
    isMaintenanceMode,
    isLoading,
    error,
    refetch,
  }
}
